var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"polling-data-rcp"}},[_c('ClaimsTable',{attrs:{"claims":_vm.claims,"loading":_vm.loading,"display-links":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }